module.exports = __webpack_public_path__ + "img/frame_3.fb14084.png";